import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button, Pagination, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField,

    MenuItem,
} from "@mui/material";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import ArrowBack from "@mui/icons-material/ArrowBack";
import apiService from "../../service/apiService";

import { Autocomplete } from "@mui/material";


const ChildFfd = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // const [farmers, setFarmers] = useState([]);
    // const [selectedFarmerId, setSelectedFarmerId] = useState("");
    // const [formattedData, setFormattedData] = useState(location.state?.formattedData || {});
    // const capacityBuildingId = formattedData?.capacityBuildingId;


    const capacityBuildingId = location.state?.capacityBuildingId;
    const [formattedData, setFormattedData] = useState({});
    const [farmers, setFarmers] = useState([]);
    const [selectedFarmerId, setSelectedFarmerId] = useState("");

    const [page, setPage] = useState(1);
    const pageSize = 10; 
    const totalItems = formattedData?.farmers?.length || 0;
    const totalPages = Math.ceil(totalItems / pageSize);

    const [openDialog, setOpenDialog] = useState(false);
    const [newFarmerName, setNewFarmerName] = useState("");




        const fetchCapacityBuildingDetails = async () => {
            if (!capacityBuildingId) {
                console.error("CapacityBuildingId is not provided");
                return;
            }
            try {
                const response = await apiService.get(`/capacity-building/getFarmerDetails/${capacityBuildingId}`);
                if (response.status === 200) {
                    setFormattedData(response.data);
                } else {
                    console.error("Failed to fetch capacity-building details");
                }
            } catch (error) {
                console.error("Error fetching capacity-building details:", error);
            }
        };
        useEffect(() => {

        fetchCapacityBuildingDetails();
    }, [capacityBuildingId]);



    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleEdit = (farmerId) => {
        console.log("Edit farmer with ID:", farmerId);
    };

    useEffect(() => {
        const fetchFarmers = async () => {
            try {
                const response = await apiService.get(
                    "/farmers/get-all"
                );
                if (response.status === 200) {
                    setFarmers(response.data); // Set the farmers data
                } else {
                    console.error("Failed to fetch farmers:", response);
                }
            } catch (error) {
                console.error("Error fetching farmers:", error);
            }
        };

        fetchFarmers();
    }, []);

    const handleDelete = async (farmerId) => {
        if (!capacityBuildingId) {
            console.error("capacityBuilding is not available");
            return;
        }

        const confirmDelete = window.confirm("Are you sure you want to delete this capacity-build?");
        if (!confirmDelete) return;

        try {
            const response = await apiService.delete(
                `/capacity-building/delete-farmer/${capacityBuildingId}/${farmerId}`
            );

            if (response.status === 200) {
                alert("capacity-building deleted successfully!");
                const updatedFarmers = formattedData.farmers.filter((farmer) => farmer.farmerId !== farmerId);
                setFormattedData({ ...formattedData, farmers: updatedFarmers });
                fetchCapacityBuildingDetails();
            } else {
                alert("Failed to delete .");
            }
        } catch (error) {
            console.error("Error deleting :", error);
            alert("An error occurred while deleting.");
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleSaveFarmer = async () => {
        if (!selectedFarmerId) {
            alert("Please select a farmer.");
            return;
        }

        if (!capacityBuildingId) {
            console.error("capacityBuilding is not available");
            return;
        }

        const payload = {
            farmerId: selectedFarmerId,
        };

        try {
            const response = await apiService.post(
                `/capacity-building/createFarmerMapping/${capacityBuildingId}`,
                payload
            );

            if (response.status === 200) {
                alert(" added successfully!");
                fetchCapacityBuildingDetails();
                const newFarmer = response.data;
                setFarmers([...farmers, newFarmer]);
                setFormattedData({
                    ...formattedData,
                    farmers: [...formattedData.farmers, newFarmer],
                });
            } else {
                alert("Failed to add farmer.");
            }
        } catch (error) {
            console.error("Error adding farmer:", error);
            alert("An error occurred while adding.");
        }

        setNewFarmerName("");
        handleCloseDialog();
        setSelectedFarmerId("");
    };



    if (!formattedData || !formattedData.farmers) {
        return <div>No data available</div>;
    }

    return (
        <div>

            <h4>Capacity-building Details</h4>


            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 2,
                    marginTop: 2,
                    marginBottom: 2,
                    paddingLeft: 2,
                }}
            >
                <Button
                    startIcon={<ArrowBack />}
                    onClick={handleBack}
                    sx={{
                        backgroundColor: "#1976d2",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#1565c0",
                        },
                        padding: "6px 16px",
                    }}
                >
                    Back
                </Button>
                {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenDialog}
                    sx={{
                        padding: "6px 16px",
                    }}
                >
                    Add Farmer
                </Button> */}
            </Box>



            <div className="table-responsive mx-2" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                <table className="table table-bordered mb-0" style={{ minWidth: "1200px" }}>
                    <thead>
                        <tr>
                            <th >PG Name</th>
                            {/* <th >Farmer ID</th> */}
                            <th >Farmer Name</th>
                            <th >Gender</th>
                            <th >Caste</th>
                            <th >Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formattedData.farmers.slice((page - 1) * pageSize, page * pageSize).map((farmer, index) => (
                            <tr key={index}>
                                <td>{farmer.producerGroupName}</td>
                                {/* <td>{farmer.farmerId}</td> */}
                                <td>{farmer.farmerName}</td>
                                <td>{farmer.gender}</td>
                                <td>{farmer.caste}</td>
                                <td>
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        {/* <button
                                            className="btn btn-md me-2"
                                            onClick={() => handleEdit(farmer.farmerId)}
                                            title="Edit"
                                        >
                                            <FaRegEdit />
                                        </button> */}
                                        <button
                                            className="btn btn-md"
                                            onClick={() => handleDelete(farmer.farmerId)}
                                            title="Delete"
                                        >
                                            <FaTrash />
                                        </button>
                                    </Box>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-between pb-0">
                <div className="p-2">
                    Showing {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, totalItems)} of {totalItems} items
                </div>
                <div className="p-2">
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                </div>
            </div>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                PaperProps={{
                    sx: {
                        width: "600px",
                        maxWidth: "600px",
                    },
                }}
            >
                <DialogTitle sx={{ marginBottom: 0 }}> Add Farmer Field Days</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        options={farmers}
                        getOptionLabel={(option) => option.farmerName || ""}
                        value={farmers.find((farmer) => farmer.farmerId === selectedFarmerId) || null}
                        onChange={(event, newValue) => {
                            setSelectedFarmerId(newValue?.farmerId || "");
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Farmer Name"
                                variant="outlined"
                                fullWidth
                                sx={{ marginTop: 2 }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="secondary">
                        Close
                    </Button>
                    <Button onClick={handleSaveFarmer} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default ChildFfd;
